"use client";

import React from "react";

import { iconColor } from "../colors";
import { createSVGIcon } from "../createSVGIcon";
import { iconCls } from "../tracking";

/**
 * @figma designed by Nick Howland (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=14271%3A836))
 * @trackcomponent
 * @lastsynced 2026-09-30T17:16:17.000Z
 * @optimized using svgo:^3.3.4
 */
export const BSREye = createSVGIcon(
  <>
    <path
      d="M21 12s-4.03 5.25-9 5.25S3 12 3 12s4.03-5.25 9-5.25S21 12 21 12Z"
      stroke="currentColor"
      strokeWidth="1.25"
    />
    <path
      d="M14.5 12a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"
      stroke="currentColor"
      strokeWidth="1.25"
    />
  </>,
  "BSREye",
  {
    className: iconCls(),
    color: iconColor.primary,
    fill: "none",
    viewBox: "0 0 24 24",
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
